import React from "react";

const Asterisk = () => {
    return <span style={{color: "#dc3545"}}>*</span>
}

export default Asterisk;